import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { getWorkdaySeries14Action,filterAction,resetFilterAction } from '../actions/index';
import { Table, Thead, Tbody, Tr, Th, Td } from 'react-super-responsive-table';
import 'react-super-responsive-table/src/SuperResponsiveTableStyle.css';
import AdminCommonSection from '../components/adminLayout';
import {constants, KeolisSpinner,Filters,Pagination} from './common/commonExport';
import PDFPrinting from './PDFPrinting';
import moment from "moment";

class SeriesGreater14 extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            showSeriesTable : false,
            numberOfPages: 0,
            pageNum: 1,
            filterState:{} 
        };
    }
    componentDidMount(){
        let pageNum = this.state.pageNum;
        this.getData(pageNum);
    }
    renderPagination() {
        let { pageNum, numberOfPages} = this.state,
            workdays = this.props.workdays, showPagination=false;
        if(workdays && workdays.length > 0 && numberOfPages > 1){
            showPagination = true;
        }
        return (<Pagination ShowPagination={showPagination} currentPage={pageNum} 
            pageSize={numberOfPages} GetData={(pageNum, filterObj) => this.getData(pageNum, filterObj)} />)
    }

    // get data for component
    getData(pageNum, filterObj){
        if(filterObj){
            filterObj = filterObj;
        } else {
            filterObj = this.state.filterState;
        }
        let page_num = filterObj.byPagination ? (pageNum) : (filterObj.byFilter ? 1 : pageNum);
        let fetchObj = {
            url:constants.actionUrls.GET_ALL_USER_SERIES,
            role: 'emp',
            source: 'web',
            filter_6 : false,
            filter_14 : true,
            pageNum:page_num,
            filterObj:filterObj
        }

        this.props.getWorkdaySeries(fetchObj,(response)=>{ 
            this.setState({
                numberOfPages: response.totalPages,
                pageNum: pageNum
            })
        });
        localStorage.setItem('route', constants.SERIES14);
    };
    componentWillMount() {
        let filterObj = this.props.filterState.defaultState ? this.props.filterState.defaultState:
                        this.props.filterState;
        filterObj["outlaw"] = false; 
        this.props.resetFilter(filterObj, response => {
            this.setState({
                filterState:response
            });
        });
    }
    // rendering claimed workdays component
    renderWorkdays(){
        if (this.props.j) {
            return(
                <tr>
                    <td>
                       <KeolisSpinner />
                    </td>
                </tr>
            );
        }
        else if (this.props.workdays && this.props.workdays.length >= 0) {
            var workdays = this.props.workdays;
            return(
                workdays.length == 0 ?
                <tr>
                    <td colSpan="100%">
                        No records available...
                    </td>
                </tr>
                :
                workdays.map(function (workday, index) {
                    return (
                        <Tr key={index} className="text-center">
                            <Td>{workday.EmployeeId} </Td>
                            <Td>{workday.emp_full_name} </Td>
                            <Td>{moment(workday.WorkDate).format("MM/DD/YYYY")} </Td>
                            <Td>{workday.Type} </Td>
                            <Td>{workday.series_14} </Td>                    
                            <Td>{workday.series_6} </Td>  
                        </Tr>
                    );
                })
            );
        } else {
            return(
                <tr>
                    <td>
                        <KeolisSpinner />
                    </td>
                </tr>
            )
        }
    }
    // filter in action
    getFilteredData(e, data){
        let pageNum = this.state.pageNum, filterObj = data;
        if(e){
            e.preventDefault();
        }        
        this.props.submitFilter(data);
        this.getData(pageNum, filterObj);
    }
    render() {
        let compTitle = '14 Series > 14 days';
        const user_admin = this.props.authDetails.role == constants.roles.ADMIN_ROLE  && !this.props.authDetails.impersonateUserId;
        let showSeriesTable = user_admin ? true : this.state.showSeriesTable ? true : false;
        return (
            <AdminCommonSection compTitle={compTitle} admin={true}
            tblBody={
                <div>
                    <Filters getData = {(e, data) => this.getFilteredData(e, data)}/>
                    <PDFPrinting compTitle = {compTitle} pageNo = {this.state.pageNum}/>
                    <div id="tblMainActivities" className = {`${showSeriesTable?"":"hidden"}`}>
                        <Table className="table table-striped table-bordered_header table-condensed">
                            <Thead className="thead-default">
                                <Tr className="text-center">
                                    <Th className="text-center">Employee Id</Th>
                                    <Th className="text-center">Full Name</Th>
                                    <Th className="text-center">Service Date</Th>
                                    <Th className="text-center">Type</Th>
                                    <Th className="text-center">14 Series</Th>
                                    <Th className="text-center">6 Series</Th>
                                </Tr>
                            </Thead>
                            <Tbody>
                            {
                                this.renderWorkdays()
                            }
                            </Tbody>
                        </Table >
                    </div>
                    { 
                        this.renderPagination()
                    }
                </div>
            }/>
        )
    }
}

function mapStateToProps(state) {
    return {
        workdays: state.series.seriesworkdays,
        isLoading: state.series.isLoading,
        authDetails:state.authState,
        employees : state.filter.employees,
        filterState:state.filter
    };
}

function matchDispatchToProps(dispatch) {
    return bindActionCreators(
        {
            getWorkdaySeries: getWorkdaySeries14Action,
            submitFilter: filterAction,
            resetFilter:resetFilterAction 
        }, dispatch);
}

export default connect(mapStateToProps, matchDispatchToProps)(SeriesGreater14);
